import { AnaColumn } from "../forms-template.service";
import { SettingGrid } from "./gridSettings/gridSettings";
const settingGrid: SettingGrid = {
  masterKey: 'id',
  keyUnique: '',
  wingap: true,
  mode: 'cell',
  selectionMode: 'single',
  remoteOperations: true,
  hoverStateEnabled: true,
  rowAlternationEnabled: true,
  repaintChangesOnly: true,
  showFilterSearch: false,
  allowUpdating: false,
  allowDeleting: false,
  allowAdding: false,
  height: 400,
  showColBlank: false,
  campoTabRif: '',
  searchAndSelect: true, //Cerca Valore e seleziona
  searchType: 'contains',
  width: 600,
  toolbarButtonsBottomLeft: null,
  toolbarButtonsBottomRight: [0],
  isOdata: true,
  overrideDataSource: null,
  concatDataField: null,
}


export const SelezioneNsAzienda: AnaColumn[] = [{
  itemType: "group", colCount: "1", class: 'no-line-caption p-3 d-flex flex-row align-items-center align-content-center justify-content-center', data: [
    {
      type: 'campoDesc',
      defaultValue: 'È necessario indicare quale proprio impianto deve emettere il FIR al RENTRi, così da procedere correttamente con la registrazione.',
      nCol: 10,
      class: 'fs-6',
      labelVisible: false,
    },
    {
      type: 'campoSpecial',
      dataField: 'emettitore',
      caption: '',
      labelVisible: false,
      colSpan: '1',
      nCol: 10,
      editorType: 'dxRadioGroup',
      validation: [{ type: 'required', message: 'Selezionare quale proprio impianto deve emettere il FIR' }],
      radioGroup: {
        dataSource: '',
        valueExpr: 'value',
        displayExpr: 'descrizione',
        layout: 'horizontal',
        static: true,
        items: [
          {
            value: 'P',
            descrizione: 'Produttore',
            alignment: 'center',
          },
          {
            value: 'T',
            descrizione: 'Trasportatore',
            alignment: 'center'
          },
        ],
      }
    }
  ]
}]